import { render } from "./ReportRender.vue?vue&type=template&id=26159c70&ts=true"
import script from "./ReportRender.vue?vue&type=script&lang=ts"
export * from "./ReportRender.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__